/** Strings of the release pages and the releases kanban: `relEn` is the source, `relCs` must have the same keys. */
export const relEn = {
  rel: {
    title: "Releases",
    disabledTitle: "Releases are disabled for this project.",
    disabledHint:
      "Enable them under <link>project settings</link> if the team wants a release-driven kanban back.",
    boardHint:
      "Drag tasks between releases to re-plan. The left-most column collects tasks without a release.",
    newRelease: "New Release",
    showOnlyOpen: "Show only open:",
    yes: "Yes ({{count}})",
    no: "No ({{count}})",
    closedHidden: "{{count}} closed hidden",
    cancel: "Cancel",
    status: {
      open: "open",
      locked: "locked",
      closed: "closed",
    },
    priority: {
      urgent: "urgent",
      high: "high",
      medium: "medium",
      low: "low",
      normal: "normal",
    },
    new: {
      title: "New Release",
      addTo: "Add a release to <link>{{project}}</link>",
      detailsTitle: "Release Details",
      detailsDescription: "Define a release for this project.",
      name: "Name",
      nameHint: "Releases are versions that follow each other (1.1, 1.2…); the name is given.",
      description: "Description",
      descriptionPlaceholder: "What is this release about?",
      dueDate: "Due Date",
      creating: "Creating…",
      create: "Create Release",
      errorForbidden: "Couldn't create the release — you may not have permission.",
      error: "Couldn't create the release.",
    },
    edit: {
      title: "Edit Release",
      pushedFirst: "Changes are pushed to GitLab first.",
      notLinked:
        "⚠ This release isn't linked to GitLab yet — saving will only update Hub. Run a gitlab_sync to (re)link.",
      name: "Name",
      nameTitle: "A version, major.minor, e.g. 1.2",
      description: "Description",
      dueDate: "Due date",
      statusLabel: "Status",
      statusOpen: "Open (active in GitLab)",
      statusLocked: "Locked (Hub-only — frozen scope)",
      statusClosed: "Closed",
      saving: "Saving…",
      save: "Save changes",
      dangerZone: "Danger zone",
      dangerDescription:
        "Deletes the release in GitLab too. Issues currently assigned to this release stay, just lose the release link.",
      deleting: "Deleting…",
      delete: "Delete release",
      confirmDelete: "Delete this release? It will be removed from GitLab too.",
      saveForbidden: "Couldn't save — you may not have permission.",
      saveError: "Couldn't save the release.",
      deleteForbidden: "Couldn't delete — only a project manager can delete a release.",
      deleteError: "Couldn't delete the release.",
    },
    detail: {
      due: "Due: ",
      allReleases: "All Releases",
      edit: "Edit",
      progress: "Progress: {{closed}} / {{total}} closed",
      issueCount_one: "{{count}} issue",
      issueCount_few: "{{count}} issues",
      issueCount_other: "{{count}} issues",
      taskCount_one: "{{count}} task",
      taskCount_few: "{{count}} tasks",
      taskCount_other: "{{count}} tasks",
      noWorkItems: "No work items assigned to this release yet.",
      noStatus: "No Status",
      colTitle: "Title",
      colPriority: "Priority",
      colAssignee: "Assignee",
      colDueDate: "Due Date",
    },
    kanban: {
      attachments_one: "{{count}} attachment",
      attachments_few: "{{count}} attachments",
      attachments_other: "{{count}} attachments",
      taskMoved: "Task moved",
      noRelease: "No release",
      releaseFallback: "release",
      couldNotMove: "Could not move task",
      networkError: "Network error",
      closedRelease: "Closed release",
      cannotAssign: "Cannot assign a task to a closed release.",
      cannotMoveOut: "Cannot move a task out of a closed release.",
      unassigned: "Unassigned",
      due: "Due ",
      frozen: "· frozen",
      dropHere: "Drop tasks here",
      waitingOnClient: "Waiting on client",
    },
  },
};

export const relCs: typeof relEn = {
  rel: {
    title: "Releasy",
    disabledTitle: "Releasy jsou pro tento projekt vypnuté.",
    disabledHint:
      "Zapněte je v <link>nastavení projektu</link>, pokud tým chce kanban řízený releasy zpět.",
    boardHint:
      "Přetahováním úkolů mezi releasy je přeplánujete. Nejlevější sloupec sbírá úkoly bez releasu.",
    newRelease: "Nový release",
    showOnlyOpen: "Zobrazit jen otevřené:",
    yes: "Ano ({{count}})",
    no: "Ne ({{count}})",
    closedHidden: "{{count}} uzavřených skryto",
    cancel: "Zrušit",
    status: {
      open: "otevřený",
      locked: "zamčený",
      closed: "uzavřený",
    },
    priority: {
      urgent: "naléhavá",
      high: "vysoká",
      medium: "střední",
      low: "nízká",
      normal: "běžná",
    },
    new: {
      title: "Nový release",
      addTo: "Přidat release do projektu <link>{{project}}</link>",
      detailsTitle: "Údaje o releasu",
      detailsDescription: "Definujte release pro tento projekt.",
      name: "Název",
      nameHint: "Releasy jsou verze, které na sebe navazují (1.1, 1.2…); název je dán.",
      description: "Popis",
      descriptionPlaceholder: "O čem tento release je?",
      dueDate: "Termín",
      creating: "Vytvářím…",
      create: "Vytvořit release",
      errorForbidden: "Release se nepodařilo vytvořit — možná na to nemáte oprávnění.",
      error: "Release se nepodařilo vytvořit.",
    },
    edit: {
      title: "Upravit release",
      pushedFirst: "Změny se nejdřív odesílají do GitLabu.",
      notLinked:
        "⚠ Tento release zatím není propojen s GitLabem — uložení změní jen Hub. Propojte ho znovu spuštěním gitlab_sync.",
      name: "Název",
      nameTitle: "Verze ve tvaru major.minor, např. 1.2",
      description: "Popis",
      dueDate: "Termín",
      statusLabel: "Stav",
      statusOpen: "Otevřený (aktivní v GitLabu)",
      statusLocked: "Zamčený (jen v Hubu — zmrazený rozsah)",
      statusClosed: "Uzavřený",
      saving: "Ukládám…",
      save: "Uložit změny",
      dangerZone: "Nebezpečná zóna",
      dangerDescription:
        "Smaže release i v GitLabu. Tikety, které jsou k tomuto releasu aktuálně přiřazené, zůstanou, jen ztratí vazbu na release.",
      deleting: "Mažu…",
      delete: "Smazat release",
      confirmDelete: "Smazat tento release? Odstraní se i z GitLabu.",
      saveForbidden: "Uložení se nepodařilo — možná na to nemáte oprávnění.",
      saveError: "Release se nepodařilo uložit.",
      deleteForbidden: "Smazání se nepodařilo — release může smazat jen projektový manažer.",
      deleteError: "Release se nepodařilo smazat.",
    },
    detail: {
      due: "Termín: ",
      allReleases: "Všechny releasy",
      edit: "Upravit",
      progress: "Průběh: {{closed}} / {{total}} uzavřeno",
      issueCount_one: "{{count}} tiket",
      issueCount_few: "{{count}} tikety",
      issueCount_other: "{{count}} tiketů",
      taskCount_one: "{{count}} úkol",
      taskCount_few: "{{count}} úkoly",
      taskCount_other: "{{count}} úkolů",
      noWorkItems: "K tomuto releasu zatím nejsou přiřazené žádné tikety.",
      noStatus: "Bez stavu",
      colTitle: "Název",
      colPriority: "Priorita",
      colAssignee: "Řešitel",
      colDueDate: "Termín",
    },
    kanban: {
      attachments_one: "{{count}} příloha",
      attachments_few: "{{count}} přílohy",
      attachments_other: "{{count}} příloh",
      taskMoved: "Úkol přesunut",
      noRelease: "Bez releasu",
      releaseFallback: "release",
      couldNotMove: "Úkol se nepodařilo přesunout",
      networkError: "Chyba sítě",
      closedRelease: "Uzavřený release",
      cannotAssign: "Úkol nelze přiřadit k uzavřenému releasu.",
      cannotMoveOut: "Úkol nelze přesunout z uzavřeného releasu.",
      unassigned: "Nepřiřazeno",
      due: "Termín ",
      frozen: "· zmrazeno",
      dropHere: "Přetáhněte úkoly sem",
      waitingOnClient: "Čeká na klienta",
    },
  },
};
